import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 0,
  class: "platform-grid__label"
}

import { computed } from 'vue'

export interface PlatformGridItem {
  key: string
  image: string
  label?: string
  title?: string
  alt?: string
  imageAlt?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PlatformGrid',
  props: {
    items: {},
    ariaLabel: { default: '' },
    desktopColumns: { default: 3 },
    tabletColumns: { default: 2 },
    mobileColumns: { default: 1 },
    gap: { default: '24px' },
    cardRadius: { default: '30px' },
    cardAspectRatio: { default: '584 / 383' },
    showLabel: { type: Boolean, default: true },
    labelFontSize: { default: 'var(--pixso-fs-36)' },
    labelLineHeight: { default: 'var(--pixso-lh-36)' },
    labelInsetX: { default: '24px' },
    labelInsetBottom: { default: '24px' },
    overlay: { default: 'linear-gradient(180deg, rgba(0, 0, 0, 0.02) 34%, rgba(0, 0, 0, 0.72) 100%)' }
  },
  setup(__props: any) {

const props = __props

const gridStyle = computed(() => ({
  '--platform-grid-columns-desktop': String(props.desktopColumns),
  '--platform-grid-columns-tablet': String(props.tabletColumns),
  '--platform-grid-columns-mobile': String(props.mobileColumns),
  '--platform-grid-gap': props.gap,
  '--platform-grid-card-radius': props.cardRadius,
  '--platform-grid-card-aspect-ratio': props.cardAspectRatio,
  '--platform-grid-label-display': props.showLabel ? 'block' : 'none',
  '--platform-grid-label-font-size': props.labelFontSize,
  '--platform-grid-label-line-height': props.labelLineHeight,
  '--platform-grid-label-inset-x': props.labelInsetX,
  '--platform-grid-label-inset-bottom': props.labelInsetBottom,
  '--platform-grid-overlay': props.overlay
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "platform-grid",
    "aria-label": _ctx.ariaLabel,
    style: _normalizeStyle(gridStyle.value)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("figure", {
        key: item.key,
        class: "platform-grid__card"
      }, [
        _createElementVNode("img", {
          class: "platform-grid__media",
          src: item.image,
          alt: item.alt || item.imageAlt || item.label || item.title || '',
          loading: "lazy"
        }, null, 8, _hoisted_2),
        (_ctx.showLabel && (item.label || item.title))
          ? (_openBlock(), _createElementBlock("figcaption", _hoisted_3, _toDisplayString(item.label || item.title), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 12, _hoisted_1))
}
}

})